import { TextInput, type TextInputProps } from '@stenajs-webui/forms';
import type { FC } from 'react';
import type { TrackerCategory } from '../../common/tracking/trackerService';
import { CopyButton } from '../../use-cases/intermodal/common/ValueTxt';
import {
  type TrackerAction,
  useTrackingTextInput,
} from '../../use-cases/simple-create/hooks/UseTrackingTextInput';

export interface CommonTextInputFieldProps
  extends Pick<
    TextInputProps,
    | 'disabled'
    | 'value'
    | 'style'
    | 'maxLength'
    | 'placeholder'
    | 'buttonRight'
    | 'buttonLeft'
    | 'id'
    | 'onBlur'
    | 'onValueChange'
  > {
  changed?: boolean;
  isValid?: boolean;
  showCopyButton?: boolean;
  trackerAction: TrackerAction;
  trackerCategory: TrackerCategory;
}

export const CommonTextInputField: FC<CommonTextInputFieldProps> = ({
  isValid = true,
  trackerCategory,
  trackerAction,
  disabled,
  changed,
  value,
  style,
  onBlur,
  showCopyButton = false,
  ...props
}) => {
  const { onBlur: internalOnBlur, onFocus } = useTrackingTextInput(trackerAction, trackerCategory);
  return (
    <TextInput
      variant={!isValid ? 'error' : undefined}
      onBlur={e => {
        onBlur?.(e);
        internalOnBlur(e);
      }}
      disabled={disabled}
      onFocus={onFocus}
      value={value}
      buttonRight={showCopyButton && value ? <CopyButton getValue={() => value} /> : undefined}
      style={{
        ...style,
        fontStyle: changed ? 'italic' : 'normal',
        fontWeight: changed ? 'bold' : 'normal',
      }}
      {...props}
    />
  );
};
